import React from 'react'
import PropTypes from 'prop-types'
import IconButton from '@mui/material/IconButton'
import { Close } from '../../assets/img/icons'

import {
  ModalWrapper,
  Overlay,
  Popup,
  CloseWrap,
  Title
} from './style'

const Modal = ({ children, title, showClose = false, onClose, modalClass = '', popupClass = '' }) => {
  const closeModal = () => {
    if (showClose) onClose()
  }
  return (
    <ModalWrapper className={`modalWrapper ${modalClass}`}>
      <Overlay onClick={closeModal} />
      <Popup className={`PopupWrapper ${popupClass}`}>
        {showClose && <CloseWrap className={'closeBtn'} onClick={closeModal}><IconButton color='primary'><Close /></IconButton></CloseWrap>}
        {title && <Title>{title}</Title>}
        {children}
      </Popup>
    </ModalWrapper>
  )
}

Modal.propTypes = {
  children: PropTypes.string,
  title: PropTypes.string,
  showClose: PropTypes.string,
  onClose: PropTypes.string,
  modalClass: PropTypes.string,
  popupClass: PropTypes.string
}

export default Modal
